<template lang="pug">
    v-container
        v-toolbar.headline.font-weight-bold(color="primary" dark)
            v-icon {{toolbarIcon}}
            span.ml-4 {{toolbarTitle}}
            .controls-area
                .switch-container(v-if="editable")
                    span.mr-2.title.pt-1 Editar
                    v-switch(v-model="editSwitch")
        v-card.px-2.py-3
            v-form(ref="form")
                v-layout(row wrap)
                    v-flex(:class="setVFlexClass(field, idx)" v-for="(field, idx) in fields" :key="idx" row wrap)
                        v-text-field.mx-3(
                            v-if="field.type == 'text' || field.type == 'password'" 
                            :type="field.type == 'password' ? 'password' : 'text'" 
                            v-bind="field.vuetifyProps"  
                            v-model="vmodels[field.field]" 
                            :rules="setRules(field)"
                            :maxlength="''+field.maxLength"
                            :readonly="!formIsFillable"
                        )
                        v-autocomplete.mx-3(
                            v-else-if="field.type == 'autocomplete'" 
                            v-bind="field.vuetifyProps" 
                            v-model="vmodels[field.field]" 
                            :items="field.options"
                            :maxlength="''+field.maxLength"
                            :readonly="!formIsFillable"

                        )
                        v-select.mx-3(
                            v-else-if="field.type == 'select'" 
                            v-bind="field.vuetifyProps" 
                            v-model="vmodels[field.field]" 
                            :items="field.options"
                            :readonly="!formIsFillable"
                        )
                        rut-input.mx-3(
                            v-else-if="field.type == 'rut'" 
                            v-bind="field.vuetifyProps" 
                            v-model="vmodels[field.field]"
                            :readonly="!formIsFillable"
                        )
                        v-textarea.mx-3(v-else-if="field.type == 'textarea'" 
                            v-bind="field.vuetifyProps" 
                            v-model="vmodels[field.field]"
                            :maxlength="''+field.maxLength"
                            :readonly="!formIsFillable"
                        )
                        v-layout(align-center v-else-if="field.type == 'checkbox'" column)
                            v-checkbox.d-flex.mx-3(
                                v-bind="field.vuetifyProps" 
                                v-model="vmodels[field.field]"
                            :readonly="!formIsFillable"
                            )
                v-layout(row wrap)
                    v-flex.px-3(xs12 md4 offset-md2)
                        v-btn.subheading.mt-3(block outline color="secondary" @click="resetForm()" :disabled="!formIsFillable") {{editable ? 'Restaurar Valores' : 'Limpiar'}}
                    v-flex.px-3(xs12 md4)
                        v-btn.subheading.mt-3(block color="secondary" @click="submitForm()" :disabled="!formIsSubmittable") {{submitText}}
</template>

<script>
import InputValidations from '@/mixins/InputValidations.js'
import RUTInput from '@/components/RUTInput/RUTInput'
import JSUtils from '@/mixins/JSUtils'
export default {
    name: 'crud-form',
    props: {
        fields: {
            type: Array,
            default: () => [],
        },
        toolbarTitle: {
            type: String,
            default: () => 'title',
        },
        toolbarIcon: {
            type: String,
            default: () => 'info',
        },
        customRules: {
            type: Object,
            default: () => {},
        },
        editable: {
            type: Boolean,
            default: false,
        },
        readOnly: {
            type: Boolean,
            default: false,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        submitText: {
            type: String,
            default: 'Enviar',
        },
    },
    data: function() {
        return {
            vmodels: {},
            editSwitch: false,
        }
    },
    computed: {
        formIsValid: function() {
            return this.$refs.form.validate()
        },
        formIsFillable: function() {
            if (!this.editable && !this.readOnly && !this.disabled) return true
            if (this.editable && this.editSwitch) return true
            return false
        },
        formIsSubmittable: function() {
            if (!this.editable && !this.readOnly && !this.disabled) return true
            if (this.editable && this.editSwitch) return true
            return false
        },
    },
    methods: {
        resetForm: function() {
            if (this.editable) {
                this.setVmodels()
                return
            }
            this.$refs.form.reset()
        },
        toggleReadOnlyForm: function(bool) {
            this.fields.forEach(field => {
                let fieldProps
                if (field.type == 'rut') {
                    fieldProps = field.vuetifyProps
                    fieldProps.textFieldProps.readonly = bool
                    field.vuetifyProps = this.mixDeepClone(fieldProps)
                    return
                }
                if (
                    field.type == 'select' ||
                    field.type == 'checkbox' ||
                    field.type == 'autocomplete'
                ) {
                    fieldProps = field.vuetifyProps
                    fieldProps.disabled = bool
                    field.vuetifyProps = this.mixDeepClone(fieldProps)
                    return
                }
                fieldProps = field.vuetifyProps
                fieldProps.readOnly = bool
                field.vuetifyProps = this.mixDeepClone(fieldProps)
            })
        },
        disabledForm: function() {},
        submitForm: function() {
            if (this.formIsValid) {
                this.$emit('submitForm', this.mixDeepClone(this.vmodels))
            }
        },
        setRules: function(field) {
            if (!field.rules) return []
            let rules = field.rules.map(ruleName => {
                return this.mixRules[ruleName]
            })
            if (!field.customRules) return rules
            let customRules = field.customRules.map(ruleName => {
                return this.customRules[ruleName]
            })
            rules = rules.concat(customRules)
            return rules
        },
        setVFlexClass: function(field, idx) {
            if (field.type != 'textarea') return { md6: true, xs12: true }
            if (field.type == 'textarea') return { md12: true, xs12: true }
            if (field.type == 'checkbox')
                return { md12: true, xs12: true, 'text-sm-center': true }
        },
        setVmodels: function() {
            let vmodels = {}
            this.fields.forEach(field => {
                vmodels[field.field] = field.value
            })
            this.vmodels = this.mixDeepClone(vmodels)
        },
    },
    watch: {
        formIsFillable: function(newVal, oldVal) {
            this.toggleReadOnlyForm(newVal ? false : true)
        },
    },
    components: {
        'rut-input': RUTInput,
    },
    mixins: [InputValidations, JSUtils],
    filters: {},
    created: function() {
        this.setVmodels()
    },
}
</script>

<style lang="scss" scoped>
.controls-area {
    width: 100%;
    display: flex;
    justify-content: flex-end;
    .switch-container {
        display: flex;
        flex-direction: row;
        padding-top: 2.5%;
        span {
            margin-top: 1px;
        }
    }
}
</style>